import { IsProdMode, ISUAT } from "../environment/IsProdMode";


export const cookieDomainConfig = {
    cookieDomain: ISUAT ? '.gujgov.edu.in' : IsProdMode ? '.gyandiksha.in' : undefined,
};

/* 
    Redirects to the Authentication Portal
*/
export const auth_baseUrl = {
    auth: ISUAT ? "https://auth.usk.gujgov.edu.in" : IsProdMode ? "https://auth.gyandiksha.in" : "http://localhost:5173"
};

export const erp_baseUrl = {
    erp: (IsProdMode || ISUAT) ? "https://testauth.gujgov.edu.in/cogent/db" : "http://localhost:5183"
};